import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AppLanguage = 'de' | 'en';

interface LangState {
  language: AppLanguage;
}

const langSlice = createSlice({
  name: 'lang',
  initialState: { language: 'de' } as LangState,
  reducers: {
    setLanguage(state, action: PayloadAction<AppLanguage>) {
      state.language = action.payload;
    },
    toggleLanguage(state) {
      state.language = state.language === 'de' ? 'en' : 'de';
    },
  },
});

export const { setLanguage, toggleLanguage } = langSlice.actions;
export default langSlice.reducer;
